import { Component, Inject, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { apiService } from 'src/app/service/api.service';
import { PlanDeMejoramientoComponent } from '../../plan-de-mejoramiento.component';
@Component({
  selector: 'app-plan-resumen',
  templateUrl: './plan-resumen.component.html',
  styleUrls: ['./plan-resumen.component.css']
})
export class PlanResumenComponent implements OnInit {

  resumenRegion = [];
  resumenPrograma = [];

  constructor(
    private api: apiService,    
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.getServerData(); 
  }

  public getServerData(){
    this.spinner.show();
    this.api.API_POST_getResumenPlanMejoraRegion().subscribe((response: any) => {
      this.resumenRegion = response.payload;
      this.api.API_POST_getResumenPlanMejoraPrograma().subscribe((response: any) => {
        this.resumenPrograma = response.payload;
        this.spinner.hide();   
      },
      (err) => {
        console.log("error"+err)
      })
        
    },
    (err) => {
      console.log("error"+err)
    })
  }
}


